<template>
  <nav class="menu-container">

    <RouterLink
      :exact="item.exact"
      v-for="item in items"
      :key="item.link"
      :to="{ name: item.name }"
      active-class="selected"
      exact-active-class=""
    >
      <div class="icon">
        <Icon :type="item.icon" />
      </div><br>
      <span>{{ item.title }}</span>
    </RouterLink>
    西乡站<br>
站点介绍<br>
西乡站东端靠近于西乡大道。新湖路北侧为大片3-7层工业厂区和合正汇一城，现代建筑密度高。南侧靠西乡大道路口为深圳市宏发地产公司正在兴建的商住两用楼，西南侧是已建成的住宅区海湾明珠、圣淘沙骏园、泰华阳光海、槟城西岸、湾上六座、富通城一到五期、金港华庭、玉湖湾等。该站为地下站。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
罗湖	06:24	23:11	1号线	2分钟	4分40秒<br>
机场东	06:09	23:57	1号线	2分钟	4分40秒<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
罗湖	06:31	23:11	1号线	3分45秒	5分45秒<br>
机场东	06:15	23:55	1号线	3分45秒	5分45秒<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
罗湖	06:31	00:11	1号线	3分45秒	5分45秒<br>
机场东	06:15	00:55	1号线	3分45秒	5分45秒<br><br>
<br>
站点出口信息<br>
A出入口:<br>
新湖路北侧（东）、西乡大道西侧（北）、合正汇一城、天虹购物中心<br><br>
B出入口:<br>
新湖路北侧（西）、盐田村、西乡客运站<br><br>
C出入口:<br>
新湖路南侧（西）、悦和路、深圳市海湾中学、深圳西湾小学、西乡体育中心、香缇湾花园、海湾明珠花园、泰华阳光海<br><br>
D出入口:<br>
新湖路南侧（东）、西乡大道西侧（南）、圣淘沙骏园、宝源新村<br>
公交换乘信息<br><br>
B出入口:<br>
公交站名： 西乡地铁站<br>
613、B847、M377、M400、M470<br><br>
D出入口:<br>
公交站名： 西乡地铁站<br>
613、718、M400、M470<br>
</nav>
</template>

<script>
// import Icon from "@/components/Icon";
export default {
  components: {
    // Icon,
  },
  data() {
    return {
      items: [
        {
          name: "yihaoxian",
          title: "1号线",
          // icon: "chat",
          exact: true,
        },
      ],
    };
  },
};
</script>

<style scoped lang="less">
@import "~@/styles/var.less";
.menu-container {
  color: @words;
  margin: 24px 0;
  a {
    &.selected {
      background: darken(@words, 3%);
    }
    padding: 0 50px;
    display: block;
    display: flex;
    align-items: center;
    height: 45px;
    // .icon {
    //   width: 24px;
    // }
    &:hover {
      color: rgb(50, 95, 227);
    }
  }
}
</style>